<div
  class="sidebar-filter-panel"
>
  <div
    class="row"
  >
    <input
      class="input-field"
      style="width: auto; flex: 1"
      type="text"
      placeholder="Поиск по фильтрам"
      (keyup)="filterSidebarFilter($event)"
    >
<!-- for future -->
<!--    <button-->
<!--      class="btn-upload"-->
<!--    >-->
<!--      <img-->
<!--        class="filter-grey-sec"-->
<!--        src="../../../../../../../../assets/icons/options.svg" alt=""-->
<!--      >-->
<!--    </button>-->
<!-- for future -->
<!--    <button-->
<!--      class="btn-options"-->
<!--    >-->
<!--      <img-->
<!--        class="filter-grey-sec"-->
<!--        src="../../../../../../../../assets/icons/upload.svg" alt=""-->
<!--      >-->
<!--    </button>-->
  </div>

  <hr class="divider-horizontal">

  <div class="row">
    <div
      class="features"
    >
      <div
        class="features-header"
      >
      <span class="features-header__title">
        Фильтры
      </span>
        <span class="counter" *ngIf="getTotalFiltered()>0">
          {{getTotalFiltered()}}
        </span>

        <button
          class="clear-all-checkboxes"
          (click)="clearAll()"
        >
          Очистить все
        </button>
      </div>

      <form [formGroup]="formFilter" (ngSubmit)="filterSubmit()" class="filter-catalog__center">
        <formly-form [form]="formFilter" [fields]="fieldsFeatures" [options]="options" (modelChange)="filterSubmit()"
                     [model]="modelFeatures"></formly-form>

      </form>

    </div>
  </div>
</div>
